import { getData, postData, deleteData } from './apiInstance';
import { AxiosResponse } from 'axios';
import { AddInvoicePayloadType, AssignColumnType, GetClientColumnPayload, GetInoviceListTypePayload } from '../commonTypes/invoicingTypes';
import { getCSRFToken } from '../utils/commonFunctions';

export async function getAllColumnsApi(token: string): Promise<AxiosResponse> {
  return await getData(`client/column/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};

export async function assignColumnsToClientsApi(data: AssignColumnType): Promise<AxiosResponse> {
  const { token, client_code, expenses, revenues, others } = data;

  let finalData = {
    client_code,
    expenses,
    revenues,
    others
  };

  return await postData(`client/column/mapping`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    }
  })
};

export async function getIndividualClientColumnListApi(data: GetClientColumnPayload): Promise<AxiosResponse> {
  const { client_code, token } = data;
  return await getData(`client/column/individual/list`, {
    params: {
      client_code
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};

export async function downloadInvoice(data: any): Promise<AxiosResponse> {
  const { token, client_code, type, start_date, end_date, date_type } = data;

  return await getData(`client/invoice/download`, {
    params: {
      client_code,
      type,
      date_type,
      start_date,
      end_date
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
}

export async function addInvoiceApi(addInvoiceData: AddInvoicePayloadType): Promise<AxiosResponse> {
  const { token, client_code, data, type } = addInvoiceData;
  const finalData = {
    type,
    client_code,
    data
  }

  return await postData(`client/invoice/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    }
  })
};

export async function editInvoiceApi(editInvoiceData: any): Promise<AxiosResponse> {
  const { token, client_code, data, type, invoice_id } = editInvoiceData;
  const finalData = {
    type,
    client_code,
    invoice_id,
    data
  }

  return await postData(`client/invoice/edit`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    }
  })
};
export async function deleteInvoiceApi(deleteInvoice: any): Promise<AxiosResponse> {
  const { token, type, invoice_id } = deleteInvoice;
  const finalData = {
    type,
    invoice_id
  }

  return await deleteData(`client/invoice/delete`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    },
    data: finalData
  })
};
export async function deleteDocumentApi(deleteDoc: any): Promise<AxiosResponse> {
  const { token, document_id } = deleteDoc;
  const finalData = {
    document_id
  }

  return await deleteData(`client/document/delete`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    },
    data: finalData
  })
};

export async function viewInvoiceApi(viewInvoicePayload: any): Promise<AxiosResponse> {
  const { token, type, client_code, invoice_id } = viewInvoicePayload;
  const params = {
    token,
    type,
    client_code,
    invoice_id

  }

  return await getData('client/invoice/view', {
    params,
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
}

export async function getExpensesInvoiceListApi(data: GetInoviceListTypePayload): Promise<AxiosResponse> {
  const { token, client_code, limit = 10, offset = 0, search_term } = data;

  return await getData(`client/invoice`, {
    params: {
      client_code,
      type: 'expenses',
      limit,
      offset,
      search_term
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};

export async function getDocumentList(data: any): Promise<AxiosResponse> {
  const { token, client_code, limit = 10, offset = 0, search_term = "" } = data;

  return await getData(`client/document`, {
    params: {
      limit,
      offset,
      client_code,
      search_term
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};

export async function uploadDocument(data: any): Promise<AxiosResponse> {
  const { token, client_code, file_name, file_type, file_url } = data;

  const finalData = {
    client_code,
    file_name,
    file_type,
    file_url
  }

  return await postData(`upload/client/document`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    }
  })
}

export async function invoiceBulkUpload(payload: any): Promise<AxiosResponse> {
  const { token, client_code, type, fileData } = payload

  const formData = new FormData()
  formData.append('client_code', client_code)
  formData.append('type', type)
  formData.append('file', fileData)

  return await postData(`upload/client/invoice`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
       "x-csrf-token":  getCSRFToken()
    }
  })
}

export async function getRevenueInvoiceListApi(data: GetInoviceListTypePayload): Promise<AxiosResponse> {
  const { token, client_code, limit = 10, offset = 0, search_term } = data;

  return await getData(`client/invoice`, {
    params: {
      client_code,
      type: 'revenue',
      offset,
      limit,
      search_term
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};

export async function getOtherEntriesListApi(data: GetInoviceListTypePayload): Promise<AxiosResponse> {
  const { token, client_code, limit = 10, offset = 0, search_term } = data;

  return await getData(`client/invoice`, {
    params: {
      client_code,
      type: 'others',
      offset,
      limit,
      search_term
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  })
};